import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
	async [actionTypes.ADITIVO_APOSTILA.CRIAR_ADITIVO_APOSTILA](context, objParam) {
		const { data } = await api.aditivoApostila.criarAditivoApostila(objParam)
		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.BUSCAR_DADOS_GERAIS_ADITIVO_APOSTILA](context, idAditivoApostila) {
		const { data } = await api.aditivoApostila.buscarDadosGeraisAditivoApostila(idAditivoApostila)
		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.SALVAR_DADOS_GERAIS_ADITIVO_APOSTILA](context, objParam) {
		const { data } = await api.aditivoApostila.salvarDadosGeraisAditivoApostila(objParam)
		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.SALVAR_QUANTIDADE_ACRESCIMO_SUPRESSAO](context, objParam) {
		const { data } = await api.aditivoApostila.salvarQuantidadeAcrescimoSupressao(
			objParam,
			objParam.idAditivoApostila,
		)
		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.CANCELAR_ACRESCIMO_SUPRESSAO](context, idAditivoApostila) {
		return await api.aditivoApostila.cancelarAcrescimoSupressao(idAditivoApostila)
	},
	async [actionTypes.ADITIVO_APOSTILA.EFETIVAR_ADITIVO_APOSTILA](context, objParam) {
		return await api.aditivoApostila.efetivarAditivoApostila(objParam)
	},
	async [actionTypes.ADITIVO_APOSTILA.BUSCAR_FORNECEDORES_POR_ITEM_ADITIVO_APOSTILA](context, idItemAditivoApostila) {
		const { data } = await api.aditivoApostila.buscarFornecedoresPorItem(idItemAditivoApostila)
		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.ALTERAR_FORNECEDOR_DO_ITEM_ADITIVO_APOSTILA](context, objParam) {
		const { data } = await api.aditivoApostila.alterarFornecedorDoItem(objParam)
		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.BUSCAR_HISTORICO_ADITIVO_APOSTILA]({ state }, { idAta, paginacao }) {
		const { data } = await api.aditivoApostila.buscarHistoricoAditivoApostila(idAta, paginacao)

		return data
	},
	async [actionTypes.ADITIVO_APOSTILA.EXISTE_DOCUMENTOS_PARA_PNCP_ADITIVO_APOSTILA](context, idAditivoApostila) {
		const { data } = await api.aditivoApostila.existeDocumentosEnvioPncp(idAditivoApostila)
		return data
	},
}
